import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { FiShare2 } from "react-icons/fi";
import ShareDashPageDialog from './ShareDashPageDialog';
const SharingDashPage = () => {
    const [isOpenShareDialog, setIsOpenShareDialog] = useState(false);
        
    return (
        <>
            <Dropdown>
                <Dropdown.Toggle
                    as="a"
                    id="dropdown-languages"
                    onClick={() => setIsOpenShareDialog(true)}
                    className="nav-link cursor-pointer arrow-none">
                    <div className="sanjabRightsidebar">
                        <FiShare2 style={{ fontSize: 22, color: 'white' }} />
                    </div>
                </Dropdown.Toggle>
            </Dropdown>

            {isOpenShareDialog &&
                <ShareDashPageDialog
                    modalOpen={isOpenShareDialog}
                    setDialogOpen={() => setIsOpenShareDialog(false)}
                />
            }
        </>
    );
};

export default SharingDashPage;
